export type RecurrencePattern = 
  | 'none'
  | 'daily' 
  | 'weekdays'
  | 'weekly'
  | 'every-monday'
  | 'every-tuesday'
  | 'every-wednesday'
  | 'every-thursday'
  | 'every-friday'
  | 'every-saturday'
  | 'every-sunday'
  | 'monthly'
  | 'yearly';

export const RECURRENCE_OPTIONS = [
  { value: 'none', label: 'Pas de récurrence' },
  { value: 'daily', label: 'Tous les jours' },
  { value: 'weekdays', label: 'Tous les jours ouvrés' },
  { value: 'weekly', label: 'Toutes les semaines' },
  { value: 'monthly', label: 'Tous les mois' },
  { value: 'yearly', label: 'Tous les ans' }
] as const;

export const RECURRENCE_OPTIONS_ACTIVE = [
  { value: 'daily', label: 'Tous les jours' },
  { value: 'weekdays', label: 'Tous les jours ouvrés' },
  { value: 'weekly', label: 'Toutes les semaines' },
  { value: 'every-monday', label: 'Tous les lundis' },
  { value: 'every-tuesday', label: 'Tous les mardis' },
  { value: 'every-wednesday', label: 'Tous les mercredis' },
  { value: 'every-thursday', label: 'Tous les jeudis' },
  { value: 'every-friday', label: 'Tous les vendredis' },
  { value: 'every-saturday', label: 'Tous les samedis' },
  { value: 'every-sunday', label: 'Tous les dimanches' },
  { value: 'monthly', label: 'Tous les mois' },
  { value: 'yearly', label: 'Tous les ans' }
] as const;